<template>
  <table
    v-if="task && results"
    class="task-entries"
  >
    <tbody>
      <tr
        v-for="(result, index) in results"
        :key="result.id"
        class="task-entry typo-small-title"
        valign="top"
      >
        <td>
          <div class="task-entry__date">
            {{ formatDate(result.captured_at) }}
          </div>
          <div class="task-entry__name typo-small">
            {{ result.name }}
          </div>
        </td>

        <td
          align="right"
          class="task-entry__value"
        >
          <strong>
            {{ formatNumber(parseFloat(result.data.value)) }} {{ task.values.unit }}
          </strong>
        </td>

        <td
          align="right"
          width="20%"
        >
          <div class="task-entry__diff">
            <div class="task-entry__diff-metric">
              <span class="task-entry__diff-indicator">
                <UseSvg
                  class="icon"
                  :name="diffIcon(result, index)"
                />
              </span>
              <span class="task-entry__diff-value">
                {{ diff(result, index) }}
              </span>
            </div>

            <div class="task-entry__comments">
              <UseSvg
                v-if="result.comments"
                class="icon icon--small"
                name="speech_bubble_16"
              />
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <Loader
    v-else
    class="task-details__loader"
  />

  <a
    :href="`${path}/new`"
    style="margin-top: 4rem"
  >New Task result</a>
</template>

<script setup>
import { inject } from 'vue';

import { formatDate } from '@/functions/date_format_helpers';

import UseSvg from '@/components/generic/use_svg.vue';
import Loader from '@/components/generic/loader.vue';

defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  planId: { type: String, required: true },
  pointId: { type: String, required: true },
  taskId: { type: String, required: true },
});

const task = inject('task');
const results = inject('results');
const path = inject('path');

function diffIcon(result, index) {
  let value = diffFromPrevious(result, index);
  if (value > 0) return 'plus_thin_24';
  if (value < 0) return 'minus_thin_24';
  return null;
}

function diffFromPrevious(result, index) {
  let prevResult = results.value[index + 1];
  if (!prevResult || parseFloat(result.data.value) === parseFloat(prevResult.data.value)) return 0;

  return parseFloat(result.data.value) - parseFloat(prevResult.data.value);
}

const numberFormat = new Intl.NumberFormat();
function formatNumber(value) {
  if (typeof value !== 'number') return '-';
  return numberFormat.format(value);
}

function diff(result, index) {
  let value = diffFromPrevious(result, index);

  if (value === 0) return '-';
  return formatNumber(value);
}
</script>
